// extracted by mini-css-extract-plugin
export default {"idleAnimation":"JumpWiggle-module__idleAnimation--TA62T","runningAnimation":"JumpWiggle-module__runningAnimation--cdpMf","copilotRun":"JumpWiggle-module__copilotRun--gYxZE"};